import React from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface ErrorPanelProps {
  title?: string
  message?: string
  onRetry?: () => void
  compact?: boolean
}

export function ErrorPanel({
  title = 'Something went wrong',
  message,
  onRetry,
  compact = false,
}: ErrorPanelProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-surface border border-border text-small text-error">
        <AlertTriangle size={14} />
        <span>{message ?? title}</span>
        {onRetry && (
          <button
            onClick={onRetry}
            className="ml-auto text-text-dim hover:text-text transition-colors"
            aria-label="Retry"
          >
            <RefreshCw size={12} />
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8 rounded-lg bg-surface border border-border text-center">
      <AlertTriangle size={32} className="text-error" />
      <div>
        <h3 className="text-subheading text-text mb-1">{title}</h3>
        {message && <p className="text-body text-text-dim max-w-md">{message}</p>}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 rounded-btn bg-surface border border-border text-text text-small hover:bg-surface-hover hover:border-border-hover transition-colors"
        >
          <RefreshCw size={14} />
          Try again
        </button>
      )}
    </div>
  )
}
